export const COMMAND_BAR_TRIGGER_ID = "commandbar-trigger";
